import ActionsPage from './ActionsPage';

export default ActionsPage;
